<template>
  <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded-lg">
    <iframe height="800" class="rounded-lg"
    src="https://medstudent.medicine.psu.ac.th/ems/alumni/index" 
    frameborder="0" allowFullScreen="true"></iframe>
  </div>
</template>
